import { useRef, useState } from 'react';

export function useTestExecution() {
  const [userOwnsTest, setUserOwnsTest] = useState(false);

  const [seconds, setSeconds] = useState(0);
  const [testStatus, setTestStatus] = useState();

  const maxDuration = useRef(0);
  const start = useRef(null);
  const queryFinished = useRef(false);
  const pollInterval = useRef(15000);
  const urlsLength = useRef(0);
  const name = useRef(null);
  const region = useRef(null);

  const [stopCount, setStopCount] = useState(false);
  const [consecutiveFails, setConsecutiveFails] = useState(0);
  const [testExecutionExists, setTestExecutionExists] = useState(true);

  return {
    userOwnsTest,
    setUserOwnsTest,
    seconds,
    setSeconds,
    testStatus,
    setTestStatus,
    maxDuration,
    start,
    queryFinished,
    pollInterval,
    urlsLength,
    name,
    region,
    stopCount,
    setStopCount,
    consecutiveFails,
    setConsecutiveFails,
    testExecutionExists,
    setTestExecutionExists,
  };
}
